// extracted by mini-css-extract-plugin
export default {"difficulty":"LibraryLessonCardDifficulty_difficulty__o7hD4"};